
























































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { http } from "@/shared/https";

@Component({
  components: {}
})
export default class FilterComponent extends Vue {
  @Prop() items: any;
  //items: any = [];  
  mainMenuid: any = null;
  subMenuId: string = null;
  count: number = 0;
  activeSection = "";
  activeSelection = "";
  itemFieldArray: any = [];

  mounted() {
    // this.getFilter().then((resp: any) => {
    //   if (resp.status >= 200 && resp.status < 300) {
    //     this.items = resp.data;
    //   }
    // });
  }

  // getFilter() {    
  //     return http.get(`api/ReviewInternal/GetFilter`); 
  // }

  toggleFilters(item) {
    if (this.activeSection === "" || this.activeSection !== item.Field) {
      this.activeSection = item.Field;
    } else {
      this.activeSection = "";
    }
  }

  toggleGreenTickIndication(event, itemField) {
    if(event === true) {
      if (this.activeSelection === "" || this.activeSelection !== itemField) {
        this.activeSelection = itemField;
        this.addToArray(this.activeSelection);
        this.activeSelection = "";
      }
    } else {
      this.activeSelection = itemField;
      this.removeFromArray(this.activeSelection);
      this.activeSelection = "";
    }
  }

  addToArray(obj) {
    this.itemFieldArray.push(obj);
  }

  removeFromArray(obj) {
    const index = this.itemFieldArray.indexOf(obj);
    if (index >= -1) {
      this.itemFieldArray.splice(index, 1);
    }
  }

  callingParentComponentMethod(filterId: any, filter: string, isChecked: boolean) {
    var self = this;  
    self.mainMenuid = this.$services.document.saveFilter(filterId, filter, self.count, self.mainMenuid, isChecked);

    this.$emit("change", self.mainMenuid);
  }

  applyFilter(field, Id){
      let isApplied = this.$services.document.filterApplied(field, Id);

      if(isApplied){
        if(!this.itemFieldArray.includes(field))
        {
          this.itemFieldArray.push(field);
        }
      }

      return isApplied;
  }

  //Clear Filter Results
  resetAction() {
    var self = this;
    self.itemFieldArray.splice(0,self.itemFieldArray.length);
    localStorage.setItem('filterBy', '{}');
    self.mainMenuid = null;
    self.$emit("change", this.mainMenuid);    
    self.$forceUpdate();
  }

  @Watch('items')
  getFilterQuery(){
    let fields = this.$services.document.filtertoQuery(this.items);
    this.$emit("change", fields);    
  }
}
